import { SERVICE_HOST } from "../utils/auth/config";

export const USER_SERVICE = `${SERVICE_HOST}/user/v1`;
export const DB_USER_SERVICE = `${USER_SERVICE}/dbUser`;
export const USER_ACTIVE_SCHOOL_YEAR = `${USER_SERVICE}/schoolyear/active/detail.json`;
export const USER_SCHOOL_YEAR_RANGE = `${USER_SERVICE}/schoolyear`; // <schoolYearKey> // detail.json
